import { COLORS } from '@btime/constants'
import { useIsOwner, useLoggedUser } from '@btime/react-session'
import { useMatch } from '@reach/router'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { cache } from '../../../utils/apollo/api'
import { setProjectId } from '../../../utils/session/sessionStorage'
import { useColor } from '../../../packages/kiti/components/theme/_hooks/colors'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useOpenEditProjectModal } from '../../../utils/routes/modals/modalsActions'
import { useReloadLoggedUser } from '../../../utils/session/reloadLoggedUser'
import { useRemoveProject } from './_requests/removeProject'
import Button from '../../../packages/kiti/components/actions/Button'
import Circle from '../../../packages/kiti/components/shapes/Circle'
import DropdownLink from '../../../components/navigation/DropdownLink'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Loading from '../../../packages/kiti/components/helpers/Loading'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text from '../../../packages/kiti/components/presentation/Text'

const ProjectListItem = ({ project }) => {
  const { t } = useTranslation(['projects', 'common'])
  const navigate = useNavigation()
  const user = useLoggedUser()

  const reloadUser = useReloadLoggedUser()
  const openEditProjectModal = useOpenEditProjectModal()
  const [removeProject, { loading }] = useRemoveProject()
  const isHomePage = useMatch('/home')
  const canEdit = user.email === 'team@btime.io' || project.createdById === user.id

  const onSelect = () => {
    setProjectId(project.id)
    reloadUser()
    cache.reset()
    if (isHomePage) {
      navigate('/')
    }
  }

  const bgColor = useColor('light1') + '70'

  if (loading) return <Loading />

  return (
    <Col width="25%">
      <Panel bgColor={bgColor} height={11} borderColor="light2">
        <Grid justify="space-between" align="center" gap={0.2}>
          <Col>
            <Circle color={project.color} size={2} radius={0.2}>
              <Icon name={project.icon || 'RiAncientGateLine'} color="white" size={1.2} />
            </Circle>
          </Col>

          <Col flex={1} />
          {canEdit && (
            <DropdownLink
              options={[
                {
                  label: t('projects:project.list.item.action.edit'),
                  icon: 'BsPencil',
                  onClick: () => openEditProjectModal({ id: project.id })
                },
                {
                  label: t('common:clone'),
                  icon: 'BsLayers',
                  onClick: () => openEditProjectModal({ id: project.id, fromTemplates: false, clone: true })
                },
                {
                  label: t('projects:project.list.item.action.remove'),
                  color: COLORS.lightRed,
                  icon: 'BsTrash',
                  onClick: () => removeProject(project.id)
                }
              ]}
              actionContent={<Icon name="BsThreeDotsVertical" color={COLORS.dark5} size="0.8rem" />}
            />
          )}
        </Grid>
        <Separator weight={3} />

        <Text size="small" bold color="dark2">
          {project.name}
        </Text>
        <Separator weight={2} />
        <Col flex={1} />
        <Button transparent bold size="xxsmall" color="dark3" onClick={onSelect}>
          {t('common:select')}
        </Button>
      </Panel>
    </Col>
  )
}

export default ProjectListItem
